module.exports = __webpack_public_path__ + "static/media/heart-svgrepo-com (10).d34019fb.svg";